import { render, staticRenderFns } from "./Diamond.vue?vue&type=template&id=f5f372b2&scoped=true"
import script from "./Diamond.vue?vue&type=script&lang=js"
export * from "./Diamond.vue?vue&type=script&lang=js"
import style0 from "./Diamond.vue?vue&type=style&index=0&id=f5f372b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f372b2",
  null
  
)

export default component.exports